import { AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';
import { useUserInfoQuery } from './query/useUserInfoQuery';

export const useUserInfoHeaders = ():
  | RawAxiosResponseHeaders
  | AxiosResponseHeaders => {
  const { data } = useUserInfoQuery();

  if (!data) {
    throw new Error(
      'Session user data is not loaded nor loading but already consumed',
    );
  }

  return data.headers;
};
